import React from 'react'
import { useIntl } from 'react-intl'
import HeadData from 'components/Common/HeadData'

import Travel from './Travel/Travel'
import OurStory from './OurStory/OurStory'
import WorkWithUs from './WorkWithUs/WorkWithUs'
import config from 'constants/config'
import ImageHero from 'components/Common/ImageHero'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import WhyBookWithUsSection from './WhyBookWithUs/WhyBookWithUsSection'
import Reviews from 'components/Pages/AboutUsPage/Reviews/Reviews'
import PartnerBrands from 'components/Common/PartnerBrands/PartnerBrands'

const HeroImage = styled(ImageHero)`
  max-height: ${rem(470)};
`

function AboutUsPage() {
  const intl = useIntl()
  const showPartnerLogos = config.logoImages && config.logoImages.length > 0

  const pageTitle = intl.formatMessage(
    {
      id: 'sr1RLWDdfd',
      defaultMessage: 'About Us - {siteTitle}',
      description: 'About Us page title with site name',
    },
    { siteTitle: config.title },
  )

  const pageDescription = intl.formatMessage({
    id: 't+niPLSvRP',
    defaultMessage: 'Information about the company, Leadership and culture',
    description: 'About Us page meta description',
  })

  const heroImageAlt = intl.formatMessage({
    id: 'BszDjW6BHy',
    defaultMessage: 'About us header image',
    description: 'Alt text for About Us hero image',
  })

  const heroHeading = intl.formatMessage({
    id: 'rs4g4D3cqj',
    defaultMessage: 'The world’s best escapes, handpicked by experts',
    description: 'About Us hero section heading',
  })

  const heroBody = intl.formatMessage({
    id: 'ToY2RUmV2X',
    defaultMessage: 'At Luxury Escapes we believe everyone should travel in style. That’s why we offer the world’s most amazing travel experiences at great prices.',
    description: 'About Us hero section body text',
  })

  return (
    <>
      <HeadData
        title={pageTitle}
        description={pageDescription}
      />
      <HeroImage
        alt={heroImageAlt}
        id="about-us-image"
      >
        <LayoutContainer>
          <Heading variant="heading2" align="center" colour="neutral-eight">
            {heroHeading}
          </Heading>
          <BodyText variant="large" align="center" colour="neutral-eight">
            {heroBody}
          </BodyText>
        </LayoutContainer>
      </HeroImage>
      <OurStory />
      <WhyBookWithUsSection />
      <Travel />
      <Reviews />
      {showPartnerLogos && <PartnerBrands />}
      <WorkWithUs />
    </>
  )
}

export default AboutUsPage
